/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : SelectDialogActionButtons.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Box } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
import CustomButtonV2 from "../../../../components/customComponentsV2/common/button/CustomButtonV2";

function SelectDialogActionButtons({
  displayBack,
  enableSubmit,
  disableBack = false,
  onClickBack = () => {},
  onClickAdd = () => {},
  onClickCancel = () => {},
}) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      {displayBack ? (
        <CustomButtonV2 btnName={"Back"} handleOnClick={onClickBack} disabled={disableBack} />
      ) : (
        <Box></Box>
      )}
      <Box sx={{ display: "flex", gap: 2 }}>
        <CustomButtonV2
          btnName={"Cancel"}
          type={"cancel"}
          handleOnClick={onClickCancel}
        />
        <CustomButtonV2
          btnName={"Add"}
          disabled={!enableSubmit}
          handleOnClick={onClickAdd}
        />
      </Box>
    </Box>
  );
}

SelectDialogActionButtons.propTypes = {
  displayBack: PropTypes.bool,
  enableSubmit: PropTypes.bool,
  disableBack: PropTypes.bool,
  onClickBack: PropTypes.func,
  onClickAdd: PropTypes.func,
  onClickCancel: PropTypes.func,
};

export default SelectDialogActionButtons;
